<template>
  <div class="row">
    <div
      v-for="(field, name, index) in config.fields"
      :key="index"
      :class="'col-md-' + field.size"
    >
      <Field
        v-if="field.enabled != false"
        :fname="name"
        :fconfig="field"
        :form="dataForm"
        v-on="$listeners"
        :findex="index"
      />
    </div>
  </div>
</template>
<script>
import Field from "./Field";

export default {
  name: "Formatter",
  props: ["config", "dataForm"],

  components: {
    Field,
  },
  // watch: {
  //   config: {
  //     handler(c) {
  //       // console.log("changed field", f.name, f.value);
  //       console.log("changed config", Date.now());
  //       console.log(c);
  //     },
  //     deep: true,
  //   },
  // }
};
</script>
